import { InitialIntegrationReducer } from "../../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../../_commons/integration.reducer";

export const initialShopifyPaymentsReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const shopifyPaymentsSlice = createSlice({
    name: "ShopifyPayments",
    initialState: { ...initialShopifyPaymentsReducer },
    reducers: {
        ...integrationReducerActions,
        validateAppstoreAccessScopesRequest(state) {
            state.isLoading = true;
        },
        
        validateAppstoreAccessScopesSuccess(state, action) {
            state.isLoading = false; 
            state.successMessage = action.payload;
        },
        
        validateAppstoreAccessScopesFailure(state, action) {
            state.isLoading = false; 
            state.errorMessage = action.payload;
        },
    },
});

export default shopifyPaymentsSlice;
